import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Cta from "../components/Cta";
import { client } from "../config/prismic";

const Guidelines = () => {
  const [guidelines, setGuidelines] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("guidelines");
      setGuidelines(response.results); // Store the guidelines data
    };
    fetchData();
  }, []);

  if (!guidelines) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  console.log(guidelines); // For debugging

  // Function to render text with spans
  const renderTextWithSpans = (text, spans) => {
    let lastIndex = 0; // Keep track of the last index processed
    const elements = []; // Array to hold the JSX elements

    spans.forEach((span) => {
      // Push text before the current span
      if (span.start > lastIndex) {
        elements.push(text.slice(lastIndex, span.start));
      }

      // Determine the span type and create the corresponding element
      if (span.type === "strong") {
        elements.push(
          <strong key={`${span.start}-${span.end}`}>
            {text.slice(span.start, span.end)}
          </strong>,
        );
      } else if (span.type === "hyperlink") {
        elements.push(
          <a
            key={`${span.start}-${span.end}`}
            href={span.data.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {text.slice(span.start, span.end)}
          </a>,
        );
      }

      // Update lastIndex to the end of the current span
      lastIndex = span.end;
    });

    // Push any remaining text after the last span
    if (lastIndex < text.length) {
      elements.push(text.slice(lastIndex));
    }

    return elements;
  };

  return (
    <div>
      <Header page={true} />
      <Cta title="Submission Guidelines" />
      <div className="container my-12 md:my-20">
        {guidelines.map((guideline, index) => (
          <div key={index} className="card shadow-lg mb-4">
            <div className="card-body">
              {guideline.data.guidelines.map((item, itemIndex) => (
                <div key={itemIndex}>
                  {item.type === "paragraph" ? (
                    <p className="card-text text-justify">
                      {renderTextWithSpans(item.text, item.spans)}
                    </p>
                  ) : (
                    <ul>
                      <li className="card-text text-justify">
                        {renderTextWithSpans(item.text, item.spans)}
                      </li>
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default Guidelines;
